'use strict';

var dateFnsTz = require('date-fns-tz');
var getSystemTimeZone = require('../../utils/getSystemTimeZone.cjs');
var getLocaleData = require('../../utils/getLocaleData.cjs');

const formatDateWithLocale = ({
  date,
  localesType,
  format,
  timeZone = getSystemTimeZone()
}) => {
  const dateFnsLocaleData = getLocaleData(localesType);
  return dateFnsTz.formatInTimeZone(date, timeZone, format, { locale: dateFnsLocaleData });
};

exports.formatDateWithLocale = formatDateWithLocale;
//# sourceMappingURL=index.cjs.map
